import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http_get } from "utils/axios";

const initialState = { dashboard: {} };

export const dashboard = createAsyncThunk(
  "dashboard/dashboard",
  async (data, { rejectWithValue }) => {
    try {
      return await http_get(`education/siswa/dashboard`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

const dashboardReducer = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    CHANGEDASHBOARDPROFILE: (state, action) => {
      state.dasboard.profile_siswa.foto = action.payload.foto;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(dashboard.fulfilled, (state, action) => {
      state.dasboard = action.payload.data.data;
    });
  },
});

export const { CHANGEDASHBOARDPROFILE } = dashboardReducer.actions;

export const selectDashboard = (state) => state.dashboard.dasboard;

export default dashboardReducer.reducer;
